import { tracker, trEnv } from 'ion-lib';

export const trackByName = (name, value) => {
  if (trEnv.vkanal === 'internet' && trEnv.mandant === 'vgh') {
    tracker('hausrat', name, value || '');
  }
};

export const trackByEvent = (e) => {
  const { name, id, value } = e.currentTarget;
  const { trackingName } = e.currentTarget.dataset;
  const trackingId = trackingName || name || id;
  trackByName(trackingId, value);
};

export const addOnBlur = (container) => (
  container.querySelectorAll(
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled])',
  )
    .forEach((elem) => {
      if (elem.getAttribute('role') === 'switch') {
        return;
      }

      if (!elem.dataset.tracking) {
        elem.addEventListener('blur', trackByEvent, true);
        elem.dataset.tracking = 'true';
      }
    })
);

export const addOnClick = (container) => (
  container.querySelectorAll(
    'a[href], button:not([disabled]), .accordion__header, .trackable',
  )
    .forEach((elem) => {
      if (!elem.dataset.tracking) {
        elem.addEventListener('click', trackByEvent, true);
        elem.dataset.tracking = 'true';
      }
    })
);
